import WindowResolver from './WindowResolver'


declare global {
  interface Window {
    pintrk(method: string, ...args: any[]): void
  }
}

/*

  From docs:

  window.pintrk('track', ...)

  Usage:

  pintrk.track(...)

 */

const windowEntity = 'pintrk'

const methods = {
  load: true,
  page: true,
  set: true,
  track: true,
}

interface IPintrk {
  // load
  // page
  // track
  track(event: 'checkoutecommerce' | 'checkout'): void
}

const pintrk = new WindowResolver({
  name: windowEntity,
  methods,
  resolver: () => Boolean(window.pintrk),
  eventHandler: (methodName, ...args) => {
    window.pintrk(methodName, ...args)
  },
}) as unknown as IPintrk


export default pintrk

export {
  windowEntity,
  methods,
}
